import React from "react";

type DayTotals = {
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
};

type HistoryDay = {
  date: string;
  totals: DayTotals;
  items?: Array<{
    name: string;
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    meal: string;
  }>;
};

export const FoodHistory: React.FC<{ history: HistoryDay[] }> = ({
  history,
}) => {
  if (!history || history.length === 0) {
    return <div style={styles.container}>No history available.</div>;
  }
  const sorted = [...history].sort((a, b) => (a.date < b.date ? 1 : -1));
  return (
    <section style={styles.container} aria-label="Food history">
      <h3 style={styles.title}>History</h3>
      <ul style={styles.list}>
        {sorted.map((d) => (
          <li key={d.date} style={styles.dayRow}>
            <div style={styles.date}>{d.date}</div>
            <div style={styles.totals}>
              <span>{d.totals.calories} kcal</span>
              <span>•</span>
              <span>{d.totals.protein} g protein</span>
              <span>•</span>
              <span>{d.totals.carbs} g carbs</span>
              <span>•</span>
              <span>{d.totals.fat} g fat</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

const styles: { [k: string]: React.CSSProperties } = {
  container: {
    padding: 12,
    background: "#252525",
    borderRadius: 8,
    color: "#fff",
    marginTop: 8,
  },
  title: { margin: 0, fontSize: 16, marginBottom: 6 },
  list: { listStyle: "none", padding: 0, margin: 0 },
  dayRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "6px 0",
    borderBottom: "1px solid #333",
  },
  date: { width: 100, fontWeight: 600, fontSize: 12, color: "#ddd" },
  totals: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    color: "#ddd",
    fontSize: 12,
  },
};

export default FoodHistory;
